import React from 'react'
import Link from 'next/link'

const SpecialPlans = () => {
  const plans_list = [
    {
      title: 'Super Starter for $4.9',
      description:
        'Add on to the community package to remove "Built With Tradly" Button. Other features same as community',
      button_title: 'Buy the Add-On',
      image: 'https://media.tradly.app/images/bdshop1/19690/Screenshot2023-12-23at7-cyr7h0NU.png',
      url: '/workspace/plans',
    },
    {
      title: 'Custom Plans',
      description:
        'Get custom plans if you have clear annual expectation and other business requirements.',
      button_title: 'Contact for a Quote',
      image: 'https://media.tradly.app/images/bdshop1/19690/Screenshot2023-12-23at7-cyr7h0NU.png',
      url: '/support',
    },
    {
      title: 'Custom Template Development',
      description:
        'If you are looking for a custom development with concierge service. Starts from $350',
      button_title: 'Contact for a Quote',
      image: 'https://media.tradly.app/images/bdshop1/19690/Screenshot2023-12-23at7-cyr7h0NU.png',
      url: '/support',
    },
  ]
  return (
    <div className=" flex   justify-center gap-10 flex-wrap">
      {plans_list?.map((plan) => {
        return (
          <div className="bg-[#E8FFFA]  shadow max-w-xs min-h-[200px]   py-10 px-5   flex-grow flex flex-col gap-8">
            <div className="  flex flex-col items-center justify-center gap-3 flex-grow">
              <img src={plan?.image} alt="" className=" h-20 object-contain" />

              <h3 className=" text-2xl font-semibold text-center">{plan?.title}</h3>
              <p className=" text-sm text-gray-600  text-center ">{plan?.description}</p>
            </div>

            <Link href={plan?.url}>
              <a className=" w-full btn_primary mx-auto">{plan?.button_title}</a>
            </Link>
          </div>
        )
      })}
    </div>
  )
}

export default SpecialPlans
